var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1340,
    height: 236,
    viewBox: "0 0 1340 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 134.575L44.6415 162.476C89.2831 190.377 178.566 246.179 267.849 223.858C357.132 201.537 446.415 101.094 535.699 84.3531C624.982 67.6125 714.265 134.575 803.548 134.575C892.831 134.575 982.114 67.6125 1071.4 73.1927C1160.68 78.7729 1249.96 156.896 1294.6 195.957L1339.25 235.018V0.650146H1294.6C1249.96 0.650146 1160.68 0.650146 1071.4 0.650146C982.114 0.650146 892.831 0.650146 803.548 0.650146C714.265 0.650146 624.982 0.650146 535.699 0.650146C446.415 0.650146 357.132 0.650146 267.849 0.650146C178.566 0.650146 89.2831 0.650146 44.6415 0.650146H0V134.575Z",
    fill: "#0A0B10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.c211ccb950a70990d5beff54e5f68bed.svg";
export { ForwardRef as ReactComponent };